export default __webpack_public_path__ + "static/media/3.f51283ea.jpg";